import { cn } from "@/lib/utils";

const gradeColors: Record<string, string> = {
  A: "bg-grade-a",
  B: "bg-grade-b",
  C: "bg-grade-c",
  D: "bg-grade-d",
};

interface GradeBadgeProps {
  grade: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function GradeBadge({ grade, size = "md", className }: GradeBadgeProps) {
  const sizeClass = {
    sm: "w-5 h-5 text-[10px]",
    md: "w-7 h-7 text-xs",
    lg: "w-9 h-9 text-sm",
  }[size];

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full font-extrabold text-white",
        sizeClass,
        gradeColors[grade] || "bg-gray-400",
        className,
      )}
    >
      {grade}
    </span>
  );
}
